/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_CreatedInputs */

const cs_documents_share_created = /** @type {(inputs: Documents_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílení vytvořeno`)
};

const en_documents_share_created = /** @type {(inputs: Documents_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share created`)
};

/**
* | output |
* | --- |
* | "Share created" |
*
* @param {Documents_Share_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_created = /** @type {((inputs?: Documents_Share_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_created(inputs)
	return cs_documents_share_created(inputs)
});